import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://bopvbykhekvrayihgfqm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvcHZieWtoZWt2cmF5aWhnZnFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODcyOTgsImV4cCI6MjA2MDE2MzI5OH0.PaJUSFBblBC7b74NrvDMNMZNMiLczHItdfJbMWCe5Lw'
);

const PeluchesPage = () => {
  const [peluches, setPeluches] = useState([]);
  const [renderVisible, setRenderVisible] = useState({});

  const toggleRender = (id) => {
    setRenderVisible((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    const fetchPeluches = async () => {
      const { data, error } = await supabase
        .from('peluches')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error al cargar peluches:', error);
      } else {
        setPeluches(data);
      }
    };

    fetchPeluches();
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '2rem' }}>🧸 Peluches Nubbi</h1>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '2rem',
      }}>
        {peluches.map((peluche) => (
          <div
            key={peluche.id}
            style={{
              background: '#f5f5f5',
              borderRadius: '20px',
              padding: '1rem',
              textAlign: 'center',
              boxShadow: '0 0 10px rgba(0,0,0,0.1)'
            }}
          >
            <img
              src={peluche.imagen_url}
              alt={peluche.nombre}
              style={{
                width: '100%',
                maxWidth: '300px',
                height: 'auto',
                borderRadius: '15px',
                marginBottom: '1rem'
              }}
            />
            <h2 style={{ margin: '0', fontSize: '1.2rem' }}>{peluche.nombre}</h2>
            <p style={{ margin: '0.3rem 0', fontWeight: 'bold' }}>NUBB ID: {peluche.nubb_id}</p>
            <p style={{ margin: '0.3rem 0', color: '#00aa88' }}>${peluche.precio} USD</p>

            {peluche.render_url && (
              <>
                <button
                  onClick={() => toggleRender(peluche.id)}
                  style={{
                    marginTop: '0.5rem',
                    background: 'none',
                    border: 'none',
                    color: '#666',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  {renderVisible[peluche.id] ? 'Ocultar diseño original' : 'Ver diseño original'}
                </button>

                {renderVisible[peluche.id] && (
                  <img
                    src={peluche.render_url}
                    alt={`Diseño original de ${peluche.nombre}`}
                    style={{
                      marginTop: '1rem',
                      width: '100%',
                      maxWidth: '250px',
                      borderRadius: '12px'
                    }}
                  />
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PeluchesPage;